import React from 'react'
import LaunchDetail from '../../components/LaunchpadDetail/LaunchDetail'


export default function LaunchpadDetail(){
  console.log('launchpadDetail page---')
  return (<>
    <LaunchDetail></LaunchDetail>
    </>)
}